const buyerEndpoint = "/api/companies/check-buyer-id?KDMSBuyerId";
const sellerEndpoint = "/api/companies/check-seller-id?KDMSSellerId";

// seller check
function checkSeller(e) {
    const loading = $(this).closest(".loading-panel-container");
    // loading 
    loading.addClass("loading");

    const id = $("#txtCompanySellerCheck").val();
    getName(sellerEndpoint, id).then(name => {
        $("#lblCompanySellerCheck").text(name);
        $("#lblCompanySellerCheck").removeClass(["bg-light", "text-muted"]);
        if (!!name) {
            $("#pnlSellerCheckSuccess").removeClass("d-none");
            $("#ckBravureManagesBuybacks").prop('disabled', false);

        } else {
            $("#lblCompanySellerCheck").text("No record found");
            $("#ckBravureManagesBuybacks").prop('disabled', true);
            $("#ckBravureManagesBuybacks").prop('checked', false);
        }
        // close loading 
        loading.removeClass("loading");
    }).catch(err => {
        $("#lblCompanySellerCheck").text("Can't connect to KDMS");
        $("#ckBravureManagesBuybacks").prop('disabled', true);
        $("#ckBravureManagesBuybacks").prop('checked', false);
        // close loading 
        loading.removeClass("loading");
    });
}
$("#btnCompanySellerCheck").click(checkSeller);
$("#txtCompanySellerCheck").keyup(function (e) {
    if (e.key !== "Enter") {
        $("#lblCompanySellerCheck").text("Seller KDMS Name");
        $("#lblCompanySellerCheck").addClass(["bg-light", "text-muted"]);
        $("#pnlSellerCheckSuccess").addClass("d-none");
    }
});
$("#txtCompanySellerCheck").keypress(function (e) {
    if (e.key === "Enter") {
        e.preventDefault();
        checkSeller(e);
    }
});

// buyer check
function checkBuyer(e) {
    const loading = $(this).closest(".loading-panel-container");
    // loading 
    loading.addClass("loading");

    const id = $("#txtCompanyBuyerCheck").val();
    getName(buyerEndpoint, id).then(name => {
        $("#lblCompanyBuyerCheck").text(name);
        $("#lblCompanyBuyerCheck").removeClass(["bg-light", "text-muted"]);
        if (!!name) {
            $("#pnlBuyerCheckSuccess").removeClass("d-none");
        } else {
            $("#lblCompanyBuyerCheck").text("No record found");
        }
        // close loading 
        loading.removeClass("loading");
    }).catch(err => {
        $("#lblCompanyBuyerCheck").text("Can't connect to KDMS");
        // close loading 
        loading.removeClass("loading");
    });
}
$("#btnCompanyBuyerCheck").click(checkBuyer);

$("#txtCompanyBuyerCheck").keyup(function (e) {
    if (e.key !== "Enter") {
        $("#lblCompanyBuyerCheck").text("Buyer KDMS Name");
        $("#lblCompanyBuyerCheck").addClass(["bg-light", "text-muted"]);
        $("#pnlBuyerCheckSuccess").addClass("d-none");
    }
});

$("#txtCompanyBuyerCheck").keypress(function (e) {
    if (e.key === "Enter") {
        e.preventDefault();
        checkBuyer(e);
    }
});
async function getName(endpoint, id) {
    // featch
    let response = await fetch(
        endpoint + "=" + id,
        {
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json"
            }
        }
    );

    const data = await response.json();
    return data.name;
}

export default undefined;
